module.exports = __webpack_public_path__ + "01ae930d559239d0c5fcca47d608e1f9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_3_0.woff2
// module id = 2255
// module chunks = 2